import { render, staticRenderFns } from "./Zugangsprobleme.vue?vue&type=template&id=76958394&scoped=true"
import script from "./Zugangsprobleme.vue?vue&type=script&lang=js"
export * from "./Zugangsprobleme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76958394",
  null
  
)

export default component.exports